import React, { useRef, useState } from "react";
import { Modal } from "react-materialize";
import { useMediaQuery } from "react-responsive";
import SetAutoBids from "./SetAutoBids";
import { NumberFormatter } from "../../../../../helpers/helpers";



function ServiceMinAndHighestPrice({
  liveOfferData,
  bidPriceUpdateValue,
  timeEnded,
  bidPlaced,
  setBidPlaced,
  startTimer,
  index
}) {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const isDesktop = useMediaQuery({ query: "(min-width: 1600px)" });
  const isLaptop = useMediaQuery({ query: "(max-width: 1200px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 920px)" });
  const isSmallTablet = useMediaQuery({ query: "(max-width: 750px)" });
  const cancelledRef = useRef(false); // Ref to track if auto-bid is canceled


  const closeModal = () => {
    setIsModalOpen(false);
  };

  // useEffect(() => {
  //   if (profile?.organization === bidPriceUpdateValue?.bidDetails?.userId) {
  //     setAutoBidValue(bidPriceUpdateValue);
  //     setDisabledCancel(false);
  //   } else {
  //     setTimeout(() => {
  //       setDisabledCancel(true);
  //     }, 7000);
  //   }
  // }, [bidPriceUpdateValue, increment, profile?.organization]);

  // useEffect(() => {
  //   if (
  //     autoBidValue?.bidDetails?.autoBidAmount >
  //     (bidPriceUpdateValue?.highestBid || 0) + 2 * increment
  //   ) {
  //     setBidPlaced(true);
  //   } else {
  //     setBidPlaced(false);
  //   }
  // }, [autoBidValue, bidPriceUpdateValue, increment, setBidPlaced]);

  // const handleCancelAutoBid = async () => {
  //   if (disabledCancel) return;
  //   cancelledRef.current = true;
  //   const data = await {
  //     offerId: liveOfferData?._id,
  //     auctionId: liveOfferData?.auction,
  //   };
  //   dispatch(cancelAutoBid(data));
  // };

  return (
    <>
      <span
        className="valign-wrapper space-between"
        style={{ order: isTablet && 1 }}
      >
        <span
          className={`${isSmallTablet
            ? "valign-wrapper gap-2 space-between"
            : "flex column gap-2"
            }`}
          style={{ padding: !isLaptop && "1rem 2rem" }}
        >
          <h5
            className={`${isSmallTablet ? "font-16px" : "font-20px"
              } margin-0px valign-wrapper gap-1`}
          >
            Min bid decrement:{" "}
            <span className="cercle-purple-text">
              Rs{" "}
              {liveOfferData?.minimumBidDecrease}

            </span>
          </h5>
          {/* {bidPlaced ? (
            <div className="valign-wrapper space-between gap-1">
              <span className="white border-radius-12 p-1">
                <h6 className={`font-20px margin-0px`}>
                  Autobid Price:{" "}
                  <span className="cercle-purple-text">
                    Rs {autoBidValue?.bidDetails?.autoBidAmount}
                  </span>
                </h6>
              </span>
              <button
                className={`font-16px pointer text-decoration-underLine ${disabledCancel ? "grey-text" : "red-text"
                  }`}
                disabled={disabledCancel}
                onClick={handleCancelAutoBid}
              >
                Cancel
              </button>
            </div>
          ) : (
            <span
              className="valign-wrapper gap-1 pointer bold font-18px justify-center white-text"
              style={{
                padding: isSmallTablet ? "8px 5px" : "0.6rem 1rem",
                borderRadius: "7px",
                width: isSmallTablet ? "200px" : isDesktop ? "" : "235px",
                border: "1px solid rgba(0, 0, 0, 0.1)",
                backgroundColor: "#363737",
              }}
              onClick={viewDetailsFunctionality}
            >
              <span className="material-icons-outlined font-25px">
                settings_suggest
              </span>
              <h6
                className={`margin-0px ${isSmallTablet ? "font-16px" : "font-18px"
                  }`}
              >
                Auto Schedule Bids
              </h6>
            </span>
          )} */}
        </span>
        {!isLaptop && (
          <p className="black" style={{ width: "0.5px", height: "100%" }}></p>
        )}
      </span>
      <span
        className="valign-wrapper column justify-center gap-1"
        style={{ order: 2 }}
      >
        <h5
          className={`${isSmallTablet ? "font-20px" : "font-30px"
            } margin-0px cercle-purple-text valign-wrapper gap-10px`}
        >
          <span>Highest Bid</span>
          <span className="material-icons-outlined black-text font-30px">
            arrow_upward
          </span>
        </h5>
        <h6
          className={`white black-text border-1px flex justify-center ${isSmallTablet ? "font-25px" : isDesktop ? "font-35px" : "font-30px"
            } margin-0px`}
          style={{
            padding: isSmallTablet
              ? "10px 30px"
              : isDesktop
                ? "15px 40px"
                : "10px 45px",
            minWidth: "200px",
          }}
        >
          {NumberFormatter(bidPriceUpdateValue?.mimumestBid || 0)}
        </h6>
      </span>
      <Modal
        actions={[]}
        open={isModalOpen}
        options={{ onCloseEnd: closeModal }}
        className="modelAccount"
        style={!isTablet ? styles.modal : styles.modelTop}
      >
        <SetAutoBids
          liveOfferData={liveOfferData}
          setIsModalOpen={setIsModalOpen}
          bidPriceUpdateValue={bidPriceUpdateValue}
          timeEnded={timeEnded}
          startTimer={startTimer}
          cancelledRef={cancelledRef}
          index={index}
        />
      </Modal>
    </>
  );
}

const styles = {
  modal: {
    width: "700px",
  },
  modelTop: {
    marginLeft: "auto",
  },
};

export default ServiceMinAndHighestPrice;
